import { CONFIG } from '@/config-globals';

type HeadProps = {
  label: string;
};

export const meta = ({ label }: HeadProps) => ({
  meta: [
    {
      title: `${CONFIG.APP_NAME} - ${label}`,
    },
  ],
});
